import { render, staticRenderFns } from "./ModalItemsRecebimentoMonitor.vue?vue&type=template&id=65b66466&scoped=true"
import script from "./ModalItemsRecebimentoMonitor.vue?vue&type=script&lang=ts"
export * from "./ModalItemsRecebimentoMonitor.vue?vue&type=script&lang=ts"
import style0 from "./ModalItemsRecebimentoMonitor.vue?vue&type=style&index=0&id=65b66466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b66466",
  null
  
)

export default component.exports